import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import axios from "axios";

function Contact() {
    // ---------------- STATE ----------------
    const [formData, setFormData] = useState({
        name: "",
        admissionClass: "",
        contact: "",
        email: "",
        message: ""
    });

    const [formErrors, setFormErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState("idle");
    const [message, setMessage] = useState("");

    // ---------------- HANDLERS ----------------
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "contact") {
            const cleaned = value.replace(/\D/g, "").slice(0, 10);
            return setFormData((prev) => ({ ...prev, contact: cleaned }));
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ---------------- VALIDATION ----------------
    const validateForm = () => {
        const errors = {};
        const phonePattern = /^[0-9]{10}$/;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.name.trim()) errors.name = "Name is required";
        if (!formData.admissionClass.trim()) errors.admissionClass = "City is required";

        if (!formData.contact.trim()) {
            errors.contact = "Phone number is required";
        } else if (!phonePattern.test(formData.contact)) {
            errors.contact = "Phone must be 10 digits";
        }

        if (formData.email && !emailPattern.test(formData.email)) {
            errors.email = "Invalid email format";
        }

        if (!formData.message.trim()) errors.message = "Message is required";

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // ---------------- SUBMIT ----------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setSubmitStatus("submitting");
        setMessage("");

        try {
            const API_URL = "https://webapi.entab.info/api/form/SMNSB/contact";

            const payload = {
                name: formData.name,
                class: formData.admissionClass,
                phone: formData.contact,
                email: formData.email,
                message: formData.message
            };

            const response = await axios.post(API_URL, payload);

            if (response.status === 200) {
                setMessage("✅ Form submitted successfully!");
                setSubmitStatus("submitted");

                // Reset form
                setFormData({
                    name: "",
                    admissionClass: "",
                    contact: "",
                    email: "",
                    message: ""
                });

                setTimeout(() => setSubmitStatus("idle"), 3000);
            }
        } catch (error) {
            console.error(error);
            setMessage("❌ Something went wrong. Try again.");
            setSubmitStatus("idle");
        }
    };

    // ---------------- UI ----------------
    return (
        <>
            <Header />

            {/* Inner Slider */}
            <section className="inr-header">
                <div className="container">
                    <div className="inr-header-content">
                        <h1 className="title">Contact</h1>
                        <ul className="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li>Contact</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Inner Body */}
            <section className="innerBody contact">
                <div className="container them-container">

                    {/* FORM */}
                    <form id="form1" onSubmit={handleSubmit}>
                        <div className="curr-blk">
                            <div className="row">

                                {/* LEFT */}
                                <div className="col-lg-6 col-md-6">
                                    {/* Name */}
                                    <div className="form-group">
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-control f-control"
                                            placeholder="Enter your Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        {formErrors.name && <p className="text-danger">{formErrors.name}</p>}
                                    </div>

                                    {/* Email */}
                                    <div className="form-group">
                                        <input
                                            name="email"
                                            type="email"
                                            className="form-control f-control"
                                            placeholder="Enter your Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {formErrors.email && <p className="text-danger">{formErrors.email}</p>}
                                    </div>

                                    {/* Phone */}
                                    <div className="form-group">
                                        <input
                                            name="contact"
                                            type="text"
                                            maxLength="10"
                                            className="form-control f-control"
                                            placeholder="Enter your Phone"
                                            value={formData.contact}
                                            onChange={handleChange}
                                            required
                                        />
                                        {formErrors.contact && <p className="text-danger">{formErrors.contact}</p>}
                                    </div>

                                    {/* City */}
                                    <div className="form-group">
                                        <input
                                            name="admissionClass"
                                            type="text"
                                            className="form-control f-control"
                                            placeholder="Enter Your City"
                                            value={formData.admissionClass}
                                            onChange={handleChange}
                                            required
                                        />
                                        {formErrors.admissionClass && <p className="text-danger">{formErrors.admissionClass}</p>}
                                    </div>
                                </div>

                                {/* RIGHT */}
                                <div className="col-lg-6 col-md-6">
                                    {/* MESSAGE */}
                                    <div className="form-group">
                                        <textarea
                                            name="message"
                                            rows="10"
                                            className="form-control"
                                            placeholder="Enter your Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                        {formErrors.message && <p className="text-danger">{formErrors.message}</p>}
                                    </div>
                                </div>

                                {/* SUBMIT */}
                                <div className="col-12">
                                    <div className="form-group">
                                        <input
                                            type="submit"
                                            value={submitStatus === "submitting" ? "Submitting..." : "Submit"}
                                            className="btn btn-warning"
                                            disabled={submitStatus === "submitting"}
                                        />
                                    </div>
                                    {message && <p className="mt-2">{message}</p>}
                                </div>

                            </div>
                        </div>
                    </form>
                    {/* Map and Contact Info */}
                    <div className="container curr-blk">
                        <div className="row">
                            <div className="map-section">
                                <div className="map">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d58466.87621557623!2d86.07253928974121!3d23.669528564941814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sSt.+Mary%E2%80%99s+Nursery+School%2C+Bokaro+(SMNS)!5e0!3m2!1sen!2sin!4v1488881969139"
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        style={{ border: 0, paddingTop: "6px", paddingLeft: "6px" }}
                                        allowFullScreen
                                        title="Google Map"
                                    ></iframe>
                                </div>

                                <div className="contact-area pt-lg-0 pb-lg-0">
                                    <div className="container">
                                        <div className="contact-wrapper">
                                            <div className="row">
                                                {/* Class Sessions */}
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="contact-item">
                                                        <div className="contact-thumb">
                                                            <img
                                                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/01.png"
                                                                alt="Class Sessions"
                                                            />
                                                        </div>
                                                        <div className="contact-content">
                                                            <h6 className="title">Class Sessions</h6>
                                                            <ul>
                                                                <li>Monday - Friday</li>
                                                                <li>08.00 am – 12.00 Noon</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* SMNS Address */}
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="contact-item">
                                                        <div className="contact-thumb">
                                                            <img
                                                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/02.png"
                                                                alt="Address"
                                                            />
                                                        </div>
                                                        <div className="contact-content">
                                                            <h6 className="title">SMNS Address</h6>
                                                            <ul>
                                                                <li>Sector - 4 - C, Near City Church, Bokaro Steel City, India 827004</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Office Hours */}
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="contact-item">
                                                        <div className="contact-thumb">
                                                            <img
                                                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/03.png"
                                                                alt="Office Hours"
                                                            />
                                                        </div>
                                                        <div className="contact-content">
                                                            <h6 className="title">Office Hours</h6>
                                                            <ul>
                                                                <li>Monday - Saturday</li>
                                                                <li>08.00 am – 02.00 pm</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Contact Info */}
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="contact-item">
                                                        <div className="contact-thumb">
                                                            <img
                                                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/04.png"
                                                                alt="Contact"
                                                            />
                                                        </div>
                                                        <div className="contact-content">
                                                            <h6 className="title">Phone & E-mail</h6>
                                                            <ul>
                                                                <li>
                                                                    <b>Call Us:</b> <a href="tel:06542232938">06542 232938</a>
                                                                </li>
                                                                <li>
                                                                    <b>WhatsApp:</b>{" "}
                                                                    <a href="https://wa.me/+916205447455" target="_blank" rel="noopener noreferrer">
                                                                        +91 6205 447 455
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="mailto:smnsbokaro@rediffmail.com">smnsbokaro@rediffmail.com</a>,{" "}
                                                                    <a href="mailto:smnsoffice@gmail.com">smnsoffice@gmail.com</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default Contact;
